import { Connector } from "../../../../../../types"
import { useDeleteConnectorMutation } from "../../../../../../redux/queries"
import { useAppDispatch } from "../../../../../hooks"
import { pushToast } from "../../../../../../redux/slices/notifications"
import { useState } from "react"
import { Pencil, Trash2 } from "lucide-react"
import DeleteConfirmationModal from "../../delete-confirmation-modal"

type Props = {
  info: Connector
  onSelect: (val: string) => void
}

const ActionsCell = ({ info, onSelect }: Props) => {
  const { id, name } = info
  const dispatch = useAppDispatch()
  const [deleteConnector, { isLoading: isDeleting }] =
    useDeleteConnectorMutation()
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation()
    onSelect(id)
  }

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    setShowDeleteModal(true)
  }

  const handleConfirmDelete = async () => {
    try {
      await deleteConnector(id).unwrap()
      dispatch(
        pushToast({
          msg: "Connector deleted successfully",
          theme: "success"
        })
      )
      setShowDeleteModal(false)
    } catch (error) {
      dispatch(
        pushToast({
          msg: "Failed to delete connector",
          theme: "danger"
        })
      )
    }
  }

  const handleCancelDelete = () => {
    setShowDeleteModal(false)
  }

  return (
    <td className="whitespace-nowrap px-3 py-4">
      <div className="flex items-center space-x-1">
        <button
          onClick={handleEdit}
          className="text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50"
          title="Edit connector"
        >
          <Pencil size={16} />
        </button>
        <button
          onClick={handleDeleteClick}
          className="text-red-600 hover:text-red-800 p-1 rounded hover:bg-red-50"
          title="Delete connector"
        >
          <Trash2 size={16} />
        </button>
      </div>

      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        connectorName={name}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        isDeleting={isDeleting}
      />
    </td>
  )
}

export default ActionsCell
